import type { IconSvgObject } from './types';

const ListCollapseIcon: IconSvgObject = [
  ["path", { d: "M9.99609 4H20.9961", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.99609 12H20.9961", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.99609 20H20.9961", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2.99609 4.5L5.99609 7.5L2.99609 10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M2.99609 13.5L5.99609 16.5L2.99609 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default ListCollapseIcon;
